import { push, ref, set } from "firebase/database";
import { PaymentData } from "../../models/payment";
import { db } from "../firebaseConfig";

export const savePayment = async (payment: PaymentData) => {
	const paymentRef = ref(db, `payments`);
	const newPaymentRef = push(paymentRef);
	await set(newPaymentRef, payment);
};
